var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.props.row.connection)?_c('i',{staticClass:"fa fa-wifi fa-lg primary"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }